<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-full h-full">
    <path fill="currentColor" d="M23 4v16H1V4h22zm-8 10.5c0-.8-.7-1.5-1.5-1.5H13c-.6 0-1 .4-1 1v4H9.5V9H12c.8 0 1.5.7 1.5 1.5V14zm-4.5 2.5h-2v-1h2v1zm5.5-7h-2.5c-.8 0-1.5.7-1.5 1.5V12h3V9.5H16V10h-1.5v.5H16v1h-1.5v.5H16v1h3v-3z"/>
  </svg>
</template>
